import { FormsProvider as Provider } from 'hooks/forms/index';
import { ManagerQueryProvider } from 'services/manager';

const FormsProvider = ({ children }) => (
	<ManagerQueryProvider>
		<Provider>{children}</Provider>
	</ManagerQueryProvider>
);

export default FormsProvider;
